import { useTheme } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";

import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import SkeletonLoaderWrapper from "../../components/mui/general/skeletonLoaderWrapper/skeletonLoaderWrapper.jsx";
import { muiDatePickersLocales } from "../../helpers/mui/muiLocales";
import useUserAction from "../../hooks/user/useUserAction";

import useUserData from "../../hooks/user/useUserData";
import { PAGE_LOGIN } from "../../locales/pages/namespaces";

import UnauthenticatedRouter from "../../routers/unauthenticatedRouter.jsx";
import Content from "./content.jsx";
import 'dayjs/locale/el'

const Main = () => {
	const { isLoggedIn, language, loading, message } = useUserData()
	const { t } = useTranslation(PAGE_LOGIN)
	dayjs.locale(language);
	const { getUserPermissions, getUserDetails, setUserMessage } = useUserAction()
	const theme = useTheme()
	useEffect(() => {
		if (isLoggedIn) {
			getUserPermissions()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoggedIn])
	
	// useEffect(() => {
	// 	if (isLoggedIn) {
	// 		// getUserDetails() //TODO::Uncomment when API is ready
	// 	}
	// }, [getUserDetails, isLoggedIn])
	
	useEffect(() => {
		if (message) {
			enqueueSnackbar(t(message?.text), {
					variant: message?.variant,
					autoHideDuration: null
				}
			)
			setUserMessage(null)
		}
	}, [message, setUserMessage, t])
	
	if (!isLoggedIn) return (
		<LocalizationProvider
			dateAdapter={AdapterDayjs}
			localeText={muiDatePickersLocales(language)}
		>
			<UnauthenticatedRouter/>
		</LocalizationProvider>
	)
	
	return (
		<SkeletonLoaderWrapper loading={loading}>
			<LocalizationProvider
				dateAdapter={AdapterDayjs}
				localeText={muiDatePickersLocales(language)}
			>
				<Content/>
			</LocalizationProvider>
		</SkeletonLoaderWrapper>
	)
}

export default Main